<template>
  <div>
    <div v-if="forConasi" class="bg-conasi vh-100">
      <toolbar />
      <div id="page-content-container">
        <core-view />
      </div>
      <bottom-view />
    </div>
    <div v-else class="d-flex flex-column bg-avatar vh-100">
      <toolbar />
      <div id="page-content">
        <core-view />
      </div>
      <footer id="sticky-footer" class="flex-shrink-0 bg-footer">
        <bottom-view />
      </footer>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { FOR_CONASI_TARGET } from 'Utils/constants'
export default {
  data: () => ({
    forConasi: FOR_CONASI_TARGET,
    favConasi: require('../../assets/favicon_conasi.png')
  }),
  mounted() {
    var link = document.querySelector("link[rel*='shortcut icon']")
    if (!link) {
      link = document.querySelector("link[rel*='icon']")
    }
    if (link) {
      link.type = "image/png";
      link.rel = "icon";
      if (this.forConasi) {
        link.href = this.favConasi
      }
    }
    this.SET_USER_DATA();
  },
  methods: {
    ...mapActions(["SET_USER_DATA"]),
  },
};
</script>
<style lang="scss" scoped>
.vh-100 {
  overflow: auto;
}
.bg-conasi {
  background-image: url('../../assets/background-intro.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.bg-avatar {
  background-image: url('../../assets/background-intro-v2.jpg');
  // background-image: url('../../assets/background-intro-shadow-avatar.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.bg-footer {
  background-image: url('../../assets/background-footer.png');
  background-size: 100% 100%;
}

#page-content-container {
  margin-top: 100px;
  margin-bottom: 2em;
}
#page-content {
  flex: 1 0 auto;
  margin-top: 95px;
}

</style>
